import { orchestrator } from 'satcheljs';
import {
    setRightPaneDisplay,
    setRightPaneDisplayAndUpdateSize,
    updatePanesSize,
} from '../actions/setPaneDisplayActions';

orchestrator(setRightPaneDisplayAndUpdateSize, actionMessage => {
    const { viewState, readingPaneDisplay, parentElementWidth } = actionMessage;
    setRightPaneDisplay(viewState, readingPaneDisplay);
    updatePanesSize(
        viewState,
        parentElementWidth === undefined
            ? viewState.leftPaneSizePixels + viewState.rightPaneSizePixels
            : parentElementWidth
    );
});
